// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"29147cc6","108":"950a16f2","223":"19225a2a","239":"ea9188bc","353":"60fdbfca","482":"a7587e7d","599":"eee6339e","663":"2d46abe2","669":"f87351e9","776":"e5af986e","891":"b8963915","903":"e140b24e","938":"3aeefa43"}[chunkId] + ".chunk.js";
};